export enum ColorEnums {
  success = 1,
  drafted = 2,
  warning = 3,
  danger = 4,
  info = 5,
}
